interface DotListProps {
  items: string[];
}

/**
 * Items separated by dots, where a wrapped line never starts or ends with a
 * dot.
 *
 * Each item draws its dot in front of itself, so no line can end with one. The
 * list is shifted one dot slot to the left inside a wrapper that clips
 * sideways, so the dot of whichever item starts a line is cut off. An item
 * that wraps on its own indents its later lines past the clipped slot.
 *
 * Repeated items are shown once.
 */
export function DotList({ items }: DotListProps) {
  return (
    <div className="overflow-x-clip">
      <ul className="[--dot:--spacing(6)] -ms-(--dot) flex flex-wrap">
        {[...new Set(items)].map((item) => (
          <li key={item} className="ps-(--dot) -indent-(--dot)">
            <span
              aria-hidden
              className="inline-block w-(--dot) indent-0 text-center"
            >
              •
            </span>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
